import {
    Box,
    Grid2,
    Typography,
} from "@mui/material";
import {
    GoogleMap,
    MarkerF,
} from '@react-google-maps/api';
import { When } from "react-if";
import { useEffect, useRef, useState } from "react";

import { ReportTypes } from "../../../../../types";
import { LatLng } from "../../../../../components/event-map";
import { markerConstants } from "../../../../../constants/marker.constants";
import dayjs from "dayjs";

interface Props {
    report: ReportTypes.Model
}

export const FieldSafetyReportResult: React.FC<Props> = ({
                                                             report,
                                                         }) => {
    const mapRef = useRef<google.maps.Map | null>(null);

    const isMountedRef = useRef<boolean>(false);

    const [center, setCenter] = useState<LatLng>(
        {
            lat: Number(report?.latitude),
            lng: Number(report?.longitude)
        }
    );
    const [zoom, setZoom] = useState<number>(18);

    const handleMapLoad = (map: google.maps.Map) => {
        mapRef.current = map;
    };

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const getReportTypeText = (reportType: string) => {
        if(!reportType) return 'N/A';
        let fieldVisitReportTypes = ["Caution","Danger","Dangerous"]
        if(reportType.includes('Incident Report'))
            reportType = reportType.replace('Incident Report', 'Field Safety Report: ');
        if(fieldVisitReportTypes.includes(reportType))
            reportType = "Field Safety Report: "+reportType
        return reportType
    }

    return (
        <Box style={{ padding: 16 }} mt={1}>
            <Grid2 container spacing={2}>
                <Grid2 size={{md:6,xs:12,sm:12}}>
                    <Grid2 container spacing={2} p={2} alignContent={'flex-start'}>
                        <Grid2 size={12}>
                            <Typography mb={2} fontWeight={400}>
                                Information About The Report
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Name:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {report?.name}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Type:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {getReportTypeText(report?.reportType)}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Comment:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {report?.reportComment}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Address:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {report?.address}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Created At:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {dayjs(report?.createdAt).format('MM/DD/YYYY hh:mm A')}
                            </Typography>
                        </Grid2>
                        <Grid2 size={{md:6,xs:12,sm:12}}>
                            <Typography fontSize={14} fontWeight={500}>
                                Last Update:
                            </Typography>
                            <Typography fontSize={14} fontWeight={400} mt={1}>
                                {dayjs(report?.updatedAt).format('MM/DD/YYYY hh:mm A')}
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Grid2>
                <Grid2 size={{md:6,xs:12,sm:12}} >
                    <Grid2 container spacing={2} p={2}alignContent={'flex-start'}>
                        <When condition={report?.latitude && report?.longitude}>
                            <Grid2 size={12}>
                                <Typography mb={2} fontWeight={400}>Location</Typography>
                                <div style={{ width: '100%', height: 400 }}>
                                    <GoogleMap
                                            onLoad={handleMapLoad}
                                            options={{
                                                disableDefaultUI: true,
                                                zoomControl: true,
                                                fullscreenControl: true,
                                                mapTypeControl: true,
                                                streetViewControl: true,
                                                scaleControl: true,
                                                rotateControl: true,
                                                clickableIcons: false,
                                                scrollwheel: true,
                                                draggable: true,
                                                draggableCursor: 'default',
                                                draggingCursor: 'pointer',
                                                keyboardShortcuts: true,
                                                disableDoubleClickZoom: false,
                                                noClear: false,
                                                styles: [
                                                    {
                                                        featureType: 'poi',
                                                        elementType: 'labels',
                                                        stylers: [
                                                            {
                                                                visibility: 'off',
                                                            },
                                                        ],
                                                    },
                                                ],
                                            }}
                                            mapContainerStyle={{ height: '100%', width: '100%' }}
                                            zoom={zoom}
                                            center={center}
                                        >
                                            <MarkerF
                                                position={{
                                                    lat: Number(report?.latitude),
                                                    lng: Number(report?.longitude)
                                                }}
                                                options={{
                                                    icon: {
                                                        url: markerConstants['report'],
                                                        scaledSize: new google.maps.Size(10, 10),
                                                        scale: 1,
                                                        origin: new google.maps.Point(0, 0),
                                                    }
                                                }}

                                            />
                                    </GoogleMap>
                                </div>
                            </Grid2>
                        </When>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Box>
    )
}